export default "__VITE_ASSET__CNh59dH4__"